import axios from "axios";

const colors = {
  primary: "#7533AF",
  heading: "#1F1F39",
};

export { colors };

export const apiKey = window.RUNTIME_API_URL;

export const logoutOn401 = (error) => {
  const status = error?.response?.status;
  const status_code = error?.response?.data?.status_code;

  if (status === 401 || status_code === 401) {
    const pathname = window.location.pathname.replace(/\/$/, "");
    if (pathname === "/admin" || pathname === "/login") {
      return false;
    }

    localStorage.removeItem("rms-admin");
    localStorage.removeItem("rms-customer");
    localStorage.removeItem("rms-outlet");

    if (window.location.pathname.startsWith("/admin")|| window.location.pathname.startsWith("/POS")) {
      window.location.href = "/admin";
    } else {
      window.location.href = "/";
    }
    return true;
  }
  return false;
};

// Automatically intercept axios responses to handle 401 errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    logoutOn401(error);
    return Promise.reject(error);
  }
);

export const aiTenant = window.RUNTIME_AI_TENANT;

export const roles = [
  { label: "Home", value: "Home" },
  { label: "Dashboard", value: "Dashboard" },
  { label: "Setting", value: "Setting" },
  { label: "Items", value: "Items" },
  { label: "Management", value: "Management" },
  { label: "Delivery", value: "Delivery" },
  { label: "Outlet", value: "Outlet" },
  { label: "Reporting", value: "Reporting" },
  { label: "All Sales", value: "All Sales" },
  { label: "Screens", value: "Screens" },
  { label: "E-Commerce", value: "E-Commerce" },
  { label: "Accounting", value: "Accounting" },
  { label: "Zatca", value: "Zatca" },
  { label: "Promotion", value: "Promotion" },
  { label: "Customer Feedback", value: "Customer Feedback" },
  { label: "Feedback", value: "Feedback" },
  { label: "Purchase", value: "Purchase" },
  { label: "Waste", value: "Waste" },
  { label: "User Section", value: "User Section" },
  { label: "Role Management", value: "Role Management" },
];

export const systemUserRoles = [
  "Home",
  "Dashboard",
  "Setting",
  "Items",
  "Management",
  "Delivery",
  "Outlet",
  "Reporting",
  "All Sales",
  "Screens",
  "E-Commerce",
  "Accounting",
  "Zatca",
  "Promotion",
  "Customer Feedback",
  "Feedback",
  "Purchase",
  "Waste",
  "User Section",
  "Role Management",
];

export const cashierRoles = ["All Sales"];

export const riderRoles = ["Delivery"];

export const displayUserRoles = ["Customer Feedback", "Feedback"];

export const accountantRoles = ["Reporting", "Purchase", "All Sales", "Waste"];

export const productManagerRoles = ["Items", "Management", "Promotion"];
